import { render, staticRenderFns } from "./NetwheelsRequests.vue?vue&type=template&id=9228057a&scoped=true"
import script from "./NetwheelsRequests.vue?vue&type=script&lang=ts"
export * from "./NetwheelsRequests.vue?vue&type=script&lang=ts"
import style0 from "./NetwheelsRequests.vue?vue&type=style&index=0&id=9228057a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9228057a",
  null
  
)

export default component.exports